import { useState } from "react";
import MultiSelect from "./MultiSelect";

## Basic Usage

export function BasicMultiSelect() {
  const [selected, setSelected] = useState([]);
  return (
    <MultiSelect
      options={[
        { label: "Apple", value: "apple" },
        { label: "Banana", value: "banana" },
        { label: "Cherry", value: "cherry" },
        { label: "Date", value: "date" },
        { label: "Elderberry", value: "elderberry" },
      ]}
      value={selected}
      onChange={setSelected}
      placeholder="Select fruits..."
    />
  );
}

<div style={{ maxWidth: "300px" }}>
  <BasicMultiSelect />
</div>

---

## With Filtering

export function FilterableMultiSelect() {
  const [selected, setSelected] = useState(["react"]);
  return (
    <MultiSelect
      options={[
        { label: "React", value: "react" },
        { label: "Vue", value: "vue" },
        { label: "Angular", value: "angular" },
        { label: "Svelte", value: "svelte" },
        { label: "Next.js", value: "nextjs" },
        { label: "Nuxt", value: "nuxt" },
        { label: "Remix", value: "remix" },
      ]}
      value={selected}
      onChange={setSelected}
      placeholder="Select frameworks..."
      filterable
    />
  );
}

<div style={{ maxWidth: "300px" }}>
  <FilterableMultiSelect />
</div>

---

## With Bulk Actions

export function BulkActionsMultiSelect() {
  const [selected, setSelected] = useState([]);
  return (
    <MultiSelect
      options={[
        { label: "Read", value: "read" },
        { label: "Write", value: "write" },
        { label: "Delete", value: "delete" },
        { label: "Admin", value: "admin" },
      ]}
      value={selected}
      onChange={setSelected}
      placeholder="Select permissions..."
      showBulkActions
    />
  );
}

<div style={{ maxWidth: "300px" }}>
  <BulkActionsMultiSelect />
</div>

---

## With Count Badge

export function CountBadgeMultiSelect() {
  const [selected, setSelected] = useState(["tag1", "tag2"]);
  return (
    <MultiSelect
      options={[
        { label: "Tag 1", value: "tag1" },
        { label: "Tag 2", value: "tag2" },
        { label: "Tag 3", value: "tag3" },
        { label: "Tag 4", value: "tag4" },
        { label: "Tag 5", value: "tag5" },
      ]}
      value={selected}
      onChange={setSelected}
      placeholder="Select tags..."
      showCountBadge
      forcePlaceholder
    />
  );
}

<div style={{ maxWidth: "300px" }}>
  <CountBadgeMultiSelect />
</div>

---

## With Option Groups

export function GroupedMultiSelect() {
  const [selected, setSelected] = useState([]);
  return (
    <MultiSelect
      options={[
        {
          label: "Frontend",
          options: [
            { label: "React", value: "react" },
            { label: "Vue", value: "vue" },
            { label: "Angular", value: "angular" },
          ],
        },
        {
          label: "Backend",
          options: [
            { label: "Node.js", value: "node" },
            { label: "Python", value: "python" },
            { label: "Go", value: "go" },
          ],
        },
      ]}
      value={selected}
      onChange={setSelected}
      placeholder="Select technologies..."
      filterable
      showBulkActions
    />
  );
}

<div style={{ maxWidth: "300px" }}>
  <GroupedMultiSelect />
</div>

---

## Disabled Options

export function DisabledOptionsMultiSelect() {
  const [selected, setSelected] = useState(["basic"]);
  return (
    <MultiSelect
      options={[
        { label: "Basic Plan", value: "basic" },
        { label: "Pro Plan", value: "pro" },
        { label: "Enterprise (Contact sales)", value: "enterprise", disabled: true, tooltip: "Contact sales to enable" },
      ]}
      value={selected}
      onChange={setSelected}
      placeholder="Select plan..."
    />
  );
}

<div style={{ maxWidth: "300px" }}>
  <DisabledOptionsMultiSelect />
</div>

---

## Disabled State

<div style={{ maxWidth: "300px" }}>
  <MultiSelect
    options={[
      { label: "Option 1", value: "1" },
      { label: "Option 2", value: "2" },
    ]}
    value={["1"]}
    onChange={() => {}}
    disabled
  />
</div>

---

## Full Featured Example

export function FullFeaturedMultiSelect() {
  const [selected, setSelected] = useState(["us", "uk"]);
  return (
    <div>
      <label style={{ display: "block", marginBottom: "0.5rem", fontWeight: 500 }}>Target Markets</label>
      <MultiSelect
        options={[
          {
            label: "North America",
            options: [
              { label: "United States", value: "us" },
              { label: "Canada", value: "ca" },
              { label: "Mexico", value: "mx" },
            ],
          },
          {
            label: "Europe",
            options: [
              { label: "United Kingdom", value: "uk" },
              { label: "Germany", value: "de" },
              { label: "France", value: "fr" },
            ],
          },
          {
            label: "Asia Pacific",
            options: [
              { label: "Japan", value: "jp" },
              { label: "Australia", value: "au" },
              { label: "Singapore", value: "sg" },
            ],
          },
        ]}
        value={selected}
        onChange={setSelected}
        placeholder="Select target markets..."
        filterable
        showBulkActions
        showCountBadge
        forcePlaceholder
      />
      <p style={{ marginTop: "0.5rem", fontSize: "14px", color: "#666" }}>
        Selected: {selected.length} market{selected.length !== 1 ? "s" : ""}
      </p>
    </div>
  );
}

<div style={{ maxWidth: "350px" }}>
  <FullFeaturedMultiSelect />
</div>


